import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import _ from "lodash";

import Wrapper from "../components/Wrapper";
import Header from "../components/Header";
import Body from "../components/Body";
import TopBar from "../components/TopBar";
import SubmitButton from "../components/SubmitButton";
import Picker from "../components/Picker";
import AddressPicker from "../components/AddressPicker";

import Typography from "@material-ui/core/Typography";
import Icon from "@material-ui/core/Icon";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from "@material-ui/core/Checkbox";
import DatePicker from "react-mobile-datepicker";
import moment from "moment";
import { FormattedInput } from "@buttercup/react-formatted-input";
import provinces from "../data/provinces";
import districts from "../data/districts";
import subdistricts from "../data/subdistricts";
import { dispatch } from "../store";

const fontDefault = {
  fontFamily: "thonburiregular",
  fontStyle: "normal",
  color: "rgb(14 22 44)"
};

const genderData = [
  {
    name: "นาย",
    value: "นาย"
  },
  {
    name: "นาง",
    value: "นาง"
  },
  {
    name: "นางสาว",
    value: "นางสาว"
  },
  {
    name: "เด็กชาย",
    value: "เด็กชาย"
  },
  {
    name: "เด็กหญิง",
    value: "เด็กหญิง"
  }
];

const gender2Data = [
  {
    name: "นาย",
    value: "นาย"
  },
  {
    name: "นาง",
    value: "นาง"
  },
  {
    name: "นางสาว",
    value: "นางสาว"
  },
  {
    name: "เด็กชาย",
    value: "เด็กชาย"
  },
  {
    name: "เด็กหญิง",
    value: "เด็กหญิง"
  }
];

const relationData = [
  {
    name: "ภรรยา",
    value: "ภรรยา"
  },
  {
    name: "สามี",
    value: "สามี"
  },
  {
    name: "บิดา",
    value: "บิดา"
  },
  {
    name: "มารดา",
    value: "มารดา"
  },
  {
    name: "พี่",
    value: "พี่"
  },
  {
    name: "น้อง",
    value: "น้อง"
  },
  {
    name: "บุตรสาว",
    value: "บุตรสาว"
  },
  {
    name: "บุตรชาย",
    value: "บุตรชาย"
  },
  {
    name: "อื่นๆ",
    value: "อื่นๆ"
  }
];

const styles = {
  textTopBar: {
    ...fontDefault,
    color: "#333333",
    fontSize: "18px",
    fontWeight: "bold"
  },
  cardHead: {
    ...fontDefault,
    fontSize: "16px",
    fontWeight: "bold"
  },
  inputHead: {
    ...fontDefault,
    fontSize: "14px",
    color: "rgb(135 139 150)",
    marginTop: "16px",
    marginBottom: "8px"
  },
  inputHeadError: {
    ...fontDefault,
    fontSize: "14px",
    color: "#ff4d4f",
    marginTop: "16px",
    marginBottom: "8px"
  },
  section: {
    padding: "24px 16px",
    backgroundColor: "white"
  },
  sectionMargin: {
    padding: "24px 16px",
    marginBottom: "8px",
    backgroundColor: "white"
  },
  fieldInput: {
    border: "1px solid rgb(188 194 210)",
    width: "100%",
    ...fontDefault,
    fontSize: "18px",
    padding: "12px 16px",
    borderRadius: "8px",
    "&::placeholder": {
      color: "rgb(195 197 203)"
    }
  },
  fieldInputError: {
    border: "1px solid #ff4d4f",
    width: "100%",
    ...fontDefault,
    fontSize: "18px",
    padding: "12px 16px",
    borderRadius: "8px",
    "&::placeholder": {
      color: "rgb(195 197 203)"
    }
  },
  flexSpace: {
    display: "flex",
    justifyContent: "space-between"
  },
  divider: {
    display: "block",
    width: "16px"
  },
  numberContainer: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "16px"
  },
  number: {
    ...fontDefault,
    fontSize: "16px",
    marginRight: "8px"
  },
  numberText: {
    ...fontDefault,
    fontSize: "16px"
  },
  radioContainer: {
    marginLeft: "24px",
    marginBottom: "24px",
    "& > fieldset": {
      width: "100%"
    },
    "& > fieldset > div > label": {
      marginRight: "0px",
      width: "50%"
    }
  },
  radioContainerFull: {
    marginLeft: "24px",
    marginBottom: "24px",
    "& > fieldset": {
      width: "100%"
    },
    "& > fieldset > div > label": {
      marginRight: "0px",
      width: "100%",
      alignItems: "flex-start"
    },
    "& > fieldset > div > label:first-of-type": {
      marginBottom: "24px"
    }
  },
  agreeC: {
    marginTop: "16px",
    height: "200px",
    padding: "10px",
    overflow: "auto",
    marginBottom: "8px",
    border: "1px solid rgb(222 225 233)",
    borderRadius: "4px"
  },
  agreeT: {
    ...fontDefault,
    color: "rgb(103 109 114)",
    fontSize: "16px"
  },
  twoContainer: {
    width: "100%"
  },

  inputContainer: {
    border: "1px solid rgb(188 194 210)",
    width: "100%",
    marginTop: "7px",
    padding: "13px 16px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  inputContainerError: {
    border: "1px solid #ff4d4f",
    width: "100%",
    marginTop: "7px",
    padding: "13px 16px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  inputContainerDisable: {
    border: "1px solid rgb(188 194 210)",
    width: "100%",
    marginTop: "7px",
    padding: "13px 16px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#EFEFEF"
  },
  fieldValueBlank: {
    ...fontDefault,
    fontSize: "16px",
    color: "rgb(195 197 203)"
  },
  fieldValue: {
    ...fontDefault,
    fontSize: "16px",
    color: "#0e162c"
  },
  errorText: {
    display: "block",
    marginTop: "8px",
    ...fontDefault,
    color: "#ff4d4f",
    fontSize: "14px"
  }
};

const scrollToRef = ref => {
  if (ref && ref.offsetTop) {
    document.getElementById("rootScreen").scrollTo(0, ref.offsetTop - 70);
  }
};

const checkID = id => {
  if (id.length !== 13) return false;
  let i = 0;
  let sum = 0;
  for (i = 0, sum = 0; i < 12; i++) sum += parseFloat(id.charAt(i)) * (13 - i);
  if ((11 - (sum % 11)) % 10 !== parseFloat(id.charAt(12))) return false;
  return true;
};

class App extends Component {
  state = {
    isShowAddressPicker: false,
    isShowPicker: false,
    pickerChoices: [],
    pickerClick: () => {},

    effDate: moment().format("YYYY-MM-DD"),
    birthdate: moment()
      .subtract(18, "years")
      .format("YYYY-MM-DD"),
    email: "",
    profiter: "relation",
    hadInsurance: "no",
    chiTravel: "no",
    reject: "no",
    wasDisease: "no",
    conDisease: "no",
    tax: "yes",
    sendingResult: "same_address",
    sendingMail: false,
    agree: false,

    emailError: false,
    datePickerEffDate: false,
    datePickerBirthdate: false
  };

  componentWillMount = () => {
    this.prefillData();
    this.loadData();
  };

  prefillData = () => {
    const { auth = {} } = this.props;
    const { user, buyFor = "self" } = auth;
    const firstName = _.get(user, "public_profile.firstname_th", "");
    const lastName = _.get(user, "public_profile.lastname_th", "");
    const email = _.get(user, "email", "");
    const phoneNumber = _.get(user, "mobile", "");
    const birthdate = _.get(user, "date_of_birth", "");
    let ID = _.get(user, "thai_id_mask", "");
    if (!!ID) {
      ID = ID.split("-").join("");
    }

    const updateSate = {};
    if (buyFor === "self") {
      if (
        !!firstName &&
        (!!localStorage.getItem(buyFor + "firstName") &&
          parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
            new Date().getTime()) === false
      )
        updateSate["firstName"] = firstName;
      if (
        !!lastName &&
        (!!localStorage.getItem(buyFor + "lastName") &&
          parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
            new Date().getTime()) === false
      )
        updateSate["lastName"] = lastName;
    }
    if (
      !!email &&
      (!!localStorage.getItem(buyFor + "email") &&
        parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
          new Date().getTime()) === false
    )
      updateSate["email"] = email;
    if (buyFor === "self") {
      if (
        !!phoneNumber &&
        (!!localStorage.getItem(buyFor + "phoneNumber") &&
          parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
            new Date().getTime()) === false
      )
        updateSate["phoneNumber"] = phoneNumber;
      if (
        !!ID &&
        (!!localStorage.getItem(buyFor + "ID") &&
          parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
            new Date().getTime()) === false
      )
        updateSate["ID"] = ID;
      if (
        !!birthdate &&
        (!!localStorage.getItem(buyFor + "birthdate") &&
          parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
            new Date().getTime()) === false
      )
        updateSate["birthdate"] = birthdate;
    }
    this.setState(updateSate);

    let addressPrefill = _.get(user, "current_address.address", "");
    // prefill address
    let provincePrefill = _.get(user, "current_address.province", "");
    // new
    let sub_district = _.get(user, "current_address.sub_district", "");
    let district = _.get(user, "current_address.district", "");
    let plain_address = _.get(user, "current_address.plain_address", "");
    let postalCodePrefill = _.get(user, "current_address.postal_code", "");

    let provinceData = provinces.find(p => {
      return p.jw_name === provincePrefill;
    });
    if (!!provinceData === false) {
      const foundID = Object.keys(subdistricts).find(sid => {
        return (
          _.get(_.get(subdistricts, sid, []), "0.zipcode", "") ===
          postalCodePrefill
        );
      });
      if (!!foundID) {
        const foundJWCode = _.get(subdistricts, foundID + ".0.jw_code", "");
        if (foundJWCode) {
          provinceData = provinces.find(p => {
            return p.jw_code === foundJWCode;
          });
        }
      }
    }
    let setAddress = false;
    if (provinceData && !!sub_district && !!district && !!plain_address) {
      const thisAmphDistrict = _.get(
        districts,
        _.get(provinceData, "jw_code", false),
        {}
      );
      const amphData = thisAmphDistrict.find(am => {
        return am.name === district || am.name === "เขต" + district;
      });
      if (amphData) {
        const mixID =
          _.get(provinceData, "jw_code", "") +
          "-" +
          _.get(amphData, "amph_code", "");
        const thisSubDistrict = _.get(subdistricts, mixID, []);
        const tumbonData = thisSubDistrict.find(tb => {
          return tb.name === sub_district;
        });
        if (
          tumbonData &&
          (!!localStorage.getItem(buyFor + "moreAddress") &&
            parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
              new Date().getTime()) === false
        ) {
          const fullAddress =
            _.get(provinceData, "jw_name", "") +
            " - " +
            _.get(amphData, "name", "") +
            " - " +
            _.get(tumbonData, "name", "") +
            " " +
            _.get(tumbonData, "zipcode", "");
          const moreAddress = {
            province: provinceData,
            district: amphData,
            subdistrict: tumbonData,
            fullAddress
          };
          dispatch({
            type: "",
            moreAddress
          });
          addressPrefill = plain_address;
          setAddress = true;
        }
      }
    }
    if (provinceData && setAddress === false) {
      const thisAmphDistrict = _.get(
        districts,
        _.get(provinceData, "jw_code", false),
        {}
      );
      const splitAddress = addressPrefill.split(" ");
      const guessDistrictName = splitAddress[splitAddress.length - 1];
      const guessSubDistrictName = splitAddress[splitAddress.length - 2];
      const amphData = thisAmphDistrict.find(am => {
        return (
          am.name === guessDistrictName || am.name === "เขต" + guessDistrictName
        );
      });
      if (amphData) {
        const mixID =
          _.get(provinceData, "jw_code", "") +
          "-" +
          _.get(amphData, "amph_code", "");
        const thisSubDistrict = _.get(subdistricts, mixID, []);
        const tumbonData = thisSubDistrict.find(tb => {
          return tb.name === guessSubDistrictName;
        });
        if (
          tumbonData &&
          (!!localStorage.getItem(buyFor + "moreAddress") &&
            parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
              new Date().getTime()) === false
        ) {
          const fullAddress =
            _.get(provinceData, "jw_name", "") +
            " - " +
            _.get(amphData, "name", "") +
            " - " +
            _.get(tumbonData, "name", "") +
            " " +
            _.get(tumbonData, "zipcode", "");
          const moreAddress = {
            province: provinceData,
            district: amphData,
            subdistrict: tumbonData,
            fullAddress
          };
          dispatch({
            type: "",
            moreAddress
          });
          addressPrefill = splitAddress.slice(0, splitAddress.length - 3);
        }
      }
    }
    if (
      !!addressPrefill &&
      (!!localStorage.getItem(buyFor + "address") &&
        parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
          new Date().getTime()) === false
    ) {
      if (
        typeof addressPrefill === "object" &&
        typeof addressPrefill.join === "function"
      ) {
        addressPrefill = addressPrefill.join(" ");
      }
      if ((addressPrefill || "").length <= 30) {
        this.setState({
          address: addressPrefill
        });
      }
    }
  };

  validate = () => {
    let {
      ID = "",
      email = "",
      phoneNumber = "",
      firstName = "",
      lastName = "",
      homeNo = "",
      moo = "",
      building = "",
      soi = "",
      road = "",
      //address = "",
      profiter = "",
      profiterRelation = "",
      profiterGender = "",
      profiterLastName = "",
      profiterFirstName = "",
      birthdate = "",
      gender = "",
      chiTravel,
      weight = "",
      height = ""
    } = this.state;
    const { auth = {} } = this.props;
    const { moreAddress = {} } = auth;
    const fullAddress = _.get(moreAddress, "fullAddress", "");
    let valid = true;
    let scroll = false;
    ID = ID.split("-").join("");
    if (!email) {
      valid = false;
      this.setState({
        emailError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.email", {}));
      if (!scroll) scroll = true;
    }
    if (
      !email.match(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      valid = false;
      this.setState({
        emailError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.email", {}));
      if (!scroll) scroll = true;
    }
    if (!phoneNumber) {
      valid = false;
      this.setState({
        phoneNumberError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.phoneNumber", {}));
      if (!scroll) scroll = true;
    }
    if (
      !phoneNumber.match(
        /^(((0|\+66)[0-9]-?([0-9]{1})?))-?([0-9]{3})-?([0-9]{3,4})$/
      )
    ) {
      valid = false;
      this.setState({
        phoneNumberError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.phoneNumber", {}));
      if (!scroll) scroll = true;
    }
    if (!ID) {
      valid = false;
      this.setState({
        IDError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.ID", {}));
      if (!scroll) scroll = true;
    }
    if (!ID.match(/\d{13}/)) {
      valid = false;
      this.setState({
        IDError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.ID", {}));
      if (!scroll) scroll = true;
    }
    if (!checkID(ID)) {
      valid = false;
      this.setState({
        IDError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.ID", {}));
      if (!scroll) scroll = true;
    }
    if (!gender) {
      valid = false;
      this.setState({
        genderError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.gender", {}));
      if (!scroll) scroll = true;
    }
    if (!firstName) {
      valid = false;
      this.setState({
        firstNameError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.firstName", {}));
      if (!scroll) scroll = true;
    }
    if (!firstName.match(/^[ก-๙0-9\s\W]+$/)) {
      valid = false;
      this.setState({
        firstNameError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.firstName", {}));
      if (!scroll) scroll = true;
    }
    if (!lastName) {
      valid = false;
      this.setState({
        lastNameError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.lastName", {}));
      if (!scroll) scroll = true;
    }
    if (!lastName.match(/^[ก-๙0-9\s\W]+$/)) {
      valid = false;
      this.setState({
        lastNameError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.lastName", {}));
      if (!scroll) scroll = true;
    }
    if (!birthdate) {
      valid = false;
      this.setState({
        birthdateError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.birthdate", {}));
      if (!scroll) scroll = true;
    }
    if (!weight) {
      valid = false;
      this.setState({
        weightError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.weight", {}));
      if (!scroll) scroll = true;
    }
    if (!weight.match(/^\d+$/)) {
      valid = false;
      this.setState({
        weightError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.weight", {}));
      if (!scroll) scroll = true;
    }
    if (!height) {
      valid = false;
      this.setState({
        heightError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.height", {}));
      if (!scroll) scroll = true;
    }
    if (!height.match(/^\d+$/)) {
      valid = false;
      this.setState({
        heightError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.height", {}));
      if (!scroll) scroll = true;
    }

    if (!homeNo) {
      valid = false;
      this.setState({
        homeNoError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.homeNo", {}));
      if (!scroll) scroll = true;
    }
    if (!!homeNo && !homeNo.match(/^[0-9\s\/-]+$/)) {
      valid = false;
      this.setState({
        homeNoError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.homeNo", {}));
      if (!scroll) scroll = true;
    }
    if (!!moo && !moo.match(/^[0-9\s\/-]+$/)) {
      valid = false;
      this.setState({
        mooError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.moo", {}));
      if (!scroll) scroll = true;
    }
    if (!!building && !building.match(/^[ก-๙0-9\s\/-]+$/)) {
      valid = false;
      this.setState({
        buildingError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.building", {}));
      if (!scroll) scroll = true;
    }
    if (!!soi && !soi.match(/^[ก-๙0-9\s\/-]+$/)) {
      valid = false;
      this.setState({
        soiError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.soi", {}));
      if (!scroll) scroll = true;
    }
    if (!road) {
      valid = false;
      this.setState({
        roadError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.road", {}));
      if (!scroll) scroll = true;
    }
    if (!!road && !road.match(/^[ก-๙0-9\s\/-]+$/)) {
      valid = false;
      this.setState({
        roadError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.road", {}));
      if (!scroll) scroll = true;
    }
    //if (!address) {
    //  valid = false;
    //  this.setState({
    //    addressError: true
    //  });
    //  if (!scroll) scrollToRef(_.get(this, "refs.address", {}));
    //  if (!scroll) scroll = true;
    //}
    //if (!address.match(/^[ก-๙0-9\s\W]+$/)) {
    //  valid = false;
    //  this.setState({
    //    addressError: true
    //  });
    //  if (!scroll) scrollToRef(_.get(this, "refs.address", {}));
    //  if (!scroll) scroll = true;
    //}
    if (!fullAddress) {
      valid = false;
      this.setState({
        moreAddressError: true
      });
      if (!scroll) scrollToRef(_.get(this, "refs.moreAddress", {}));
      if (!scroll) scroll = true;
    }
    if (profiter === "other") {
      if (!profiterRelation) {
        valid = false;
        this.setState({
          profiterRelationError: true
        });
        if (!scroll) scrollToRef(_.get(this, "refs.profiterRelation", {}));
        if (!scroll) scroll = true;
      }
      if (!profiterGender) {
        valid = false;
        this.setState({
          profiterGenderError: true
        });
        if (!scroll) scrollToRef(_.get(this, "refs.profiterGender", {}));
        if (!scroll) scroll = true;
      }
      if (!profiterFirstName) {
        valid = false;
        this.setState({
          profiterFirstNameError: true
        });
        if (!scroll) scrollToRef(_.get(this, "refs.profiterFirstName", {}));
        if (!scroll) scroll = true;
      }
      if (!profiterLastName) {
        valid = false;
        this.setState({
          profiterLastNameError: true
        });
        if (!scroll) scrollToRef(_.get(this, "refs.profiterLastName", {}));
        if (!scroll) scroll = true;
      }
    }

    if (chiTravel === "yes") {
      const {
        history: { push }
      } = this.props;
      push("/error-uw");
      document.getElementById("rootScreen").scrollTo(0, 0);
      return;
    }

    return valid;
  };

  loadData = () => {
    const { auth = {} } = this.props;
    const { buyFor = "self" } = auth;
    let value;
    const hadInsuranceLoaded = _.get(this.state, "hadInsuranceLoad", false);
    if (
      !!localStorage.getItem(buyFor + "hadInsurance") &&
      !!hadInsuranceLoaded === false &&
      parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
        new Date().getTime()
    ) {
      value = localStorage.getItem(buyFor + "hadInsurance");
      this.state["hadInsuranceLoad"] = true;
      this.state["hadInsurance"] = value || "no";
    } else {
      if (hadInsuranceLoaded === false) {
        this.state["hadInsuranceLoad"] = true;
        localStorage.setItem(buyFor + "hadInsurance", value || "no");
      }
    }
    const chiTravelLoaded = _.get(this.state, "chiTravelLoad", false);
    if (
      !!localStorage.getItem(buyFor + "chiTravel") &&
      !!chiTravelLoaded === false &&
      parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
        new Date().getTime()
    ) {
      value = localStorage.getItem(buyFor + "chiTravel");
      this.state["chiTravelLoad"] = true;
      this.state["chiTravel"] = value || "no";
    } else {
      if (chiTravelLoaded === false) {
        this.state["chiTravelLoad"] = true;
        localStorage.setItem(buyFor + "chiTravel", value || "no");
      }
    }
    const rejectLoaded = _.get(this.state, "rejectLoad", false);
    if (
      !!localStorage.getItem(buyFor + "reject") &&
      !!rejectLoaded === false &&
      parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
        new Date().getTime()
    ) {
      value = localStorage.getItem(buyFor + "reject");
      this.state["rejectLoad"] = true;
      this.state["reject"] = value || "no";
    } else {
      if (rejectLoaded === false) {
        this.state["rejectLoad"] = true;
        localStorage.setItem(buyFor + "reject", value || "no");
      }
    }
    const wasDiseaseLoaded = _.get(this.state, "wasDiseaseLoad", false);
    if (
      !!localStorage.getItem(buyFor + "wasDisease") &&
      !!wasDiseaseLoaded === false &&
      parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
        new Date().getTime()
    ) {
      value = localStorage.getItem(buyFor + "wasDisease");
      this.state["wasDiseaseLoad"] = true;
      this.state["wasDisease"] = value || "no";
    } else {
      if (wasDiseaseLoaded === false) {
        this.state["wasDiseaseLoad"] = true;
        localStorage.setItem(buyFor + "wasDisease", value || "no");
      }
    }
    const conDiseaseLoaded = _.get(this.state, "conDiseaseLoad", false);
    if (
      !!localStorage.getItem(buyFor + "conDisease") &&
      !!conDiseaseLoaded === false &&
      parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
        new Date().getTime()
    ) {
      value = localStorage.getItem(buyFor + "conDisease");
      this.state["conDiseaseLoad"] = true;
      this.state["conDisease"] = value || "no";
    } else {
      if (conDiseaseLoaded === false) {
        this.state["conDiseaseLoad"] = true;
        localStorage.setItem(buyFor + "conDisease", value || "no");
      }
    }
    const taxLoaded = _.get(this.state, "taxLoad", false);
    if (
      !!localStorage.getItem(buyFor + "tax") &&
      !!taxLoaded === false &&
      parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
        new Date().getTime()
    ) {
      value = localStorage.getItem(buyFor + "tax");
      this.state["taxLoad"] = true;
      this.state["tax"] = value || "yes";
    } else {
      if (taxLoaded === false) {
        this.state["taxLoad"] = true;
        localStorage.setItem(buyFor + "tax", value || "yes");
      }
    }
    const moreAddressLoaded = _.get(this.state, "moreAddressLoad", false);
    if (
      !!localStorage.getItem(buyFor + "moreAddress") &&
      !!moreAddressLoaded === false &&
      parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
        new Date().getTime()
    ) {
      try {
        value = JSON.parse(localStorage.getItem(buyFor + "moreAddress"));
        this.state["moreAddressLoad"] = true;
        dispatch({
          type: "",
          moreAddress: value
        });
      } catch (error) {
        this.state["moreAddressLoad"] = true;
        dispatch({
          type: "",
          moreAddress: {}
        });
      }
    } else {
      if (moreAddressLoaded === false) {
        this.state["moreAddressLoad"] = true;
        localStorage.setItem(buyFor + "moreAddress", value || "");
      }
    }
  };

  goToNextPage = () => {
    if (this.validate()) {
      const { auth = {} } = this.props;
      const { selectedPackage = {}, buyFor = "self" } = auth;
      const mixpanel = _.get(window, "mixpanel", undefined);
      if (!!mixpanel) {
        mixpanel.track("Insurance Corona Fill Info", {
          Insurer: "Dhipaya",
          "Insurance type": "Dhipaya Corona",
          "Insurance package": selectedPackage.name,
          Amount: selectedPackage.total_prem,
          Recipient: buyFor === "self" ? "Buy for self" : "Buy for others"
        });
      }
      this.save();
      const {
        history: { push }
      } = this.props;
      push("/summary");
      document.getElementById("rootScreen").scrollTo(0, 0);
    }
  };

  componentDidMount = () => {
    const { auth = {} } = this.props;
    const { userInput = {} } = auth;
    if (userInput.profiter) {
      this.setState({
        profiter: userInput.profiter
      });
    }
  };

  save = () => {
    dispatch({
      type: "",
      userInput: {
        ...this.state
      }
    });
  };

  backToPreviousPage = () => {
    const {
      history: { push },
      auth = {}
    } = this.props;
    const { version = "v1" } = auth;
    if (version !== "v1") {
      push("/packages");
    } else {
      push("/packages-old");
    }
    document.getElementById("rootScreen").scrollTo(0, 0);
  };

  renderErrorText = (keyName, value) => {
    switch (keyName) {
      case "ID":
        return (value || "").length === 0
          ? "กรุณากรอกเลขบัตรประชาชน"
          : "เลขบัตรประชาชนไม่ถูกต้อง";
        break;
      case "email":
        return (value || "").length === 0
          ? "กรุณากรอกอีเมล"
          : "อีเมลไม่ถูกต้อง";
        break;
      case "phoneNumber":
        return "กรุณากรอกเบอร์โทรติดต่อ";
        break;
      case "firstName":
        return "กรุณากรอกชื่อจริงเป็นภาษาไทย";
        break;
      case "lastName":
        return "กรุณากรอกนามสกุลเป็นภาษาไทย";
        break;
      //case "address":
      //  return "กรุณากรอกบ้านเลขที่ ถนน เป็นภาษาไทย";
      //  break;
      case "homeNo":
        return (value || "").length === 0
          ? "กรุณากรอกบ้านเลขที่"
          : "บ้านเลขที่ไม่ถูกต้อง (ตัวเลข หรือ /)";
        break;
      case "moo":
        return "หมู่ไม่ถูกต้อง (ตัวเลข หรือ /)";
        break;
      case "building":
        return "กรุณากรอกชื่ออาคาร/หมู่บ้านเป็นภาษาไทย";
        break;
      case "soi":
        return "กรุณากรอกซอยเป็นภาษาไทย";
        break;
      case "road":
        return "กรุณากรอกถนนเป็นภาษาไทย";
        break;
      case "moreAddress":
        return "กรุณาเลือกข้อมูล";
        break;
      case "gender":
        return "กรุณาเลือกคำนำหน้า";
        break;
      case "profiterGender":
        return "กรุณาเลือกคำนำหน้า";
        break;
      case "profiterFirstName":
        return "กรุณากรอกชื่อจริงเป็นภาษาไทย";
        break;
      case "profiterLastName":
        return "กรุณากรอกนามสกุลเป็นภาษาไทย";
        break;
      case "profiterRelation":
        return "กรุณาเลือกความสัมพันธ์";
        break;
      case "birthdate":
        return "กรุณาเลือกวัน/เดือน/ปีเกิด";
        break;
      case "weight":
        return "กรุณากรอกน้ำหนัก";
        break;
      case "height":
        return "กรุณากรอกส่วนสูง";
        break;
      default:
        return "";
        break;
    }
  };

  renderTextInput = (
    name,
    keyName,
    errorKeyName,
    placeholder,
    otherProps = {}
  ) => {
    const { classes, auth = {} } = this.props;
    const { buyFor = "self" } = auth;
    let value = _.get(this.state, keyName, "");
    const valueError = _.get(this.state, errorKeyName, false);
    const loaded = _.get(this.state, keyName + "Load", false);
    if (
      !!localStorage.getItem(buyFor + keyName) &&
      !!loaded === false &&
      parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
        new Date().getTime()
    ) {
      value = localStorage.getItem(buyFor + keyName);
      this.state[keyName + "Load"] = true;
      this.state[keyName] = value;
    } else {
      if (loaded === false) {
        this.state[keyName + "Load"] = true;
        localStorage.setItem(buyFor + keyName, value);
      }
    }
    return (
      <div ref={keyName}>
        <Typography className={classes.inputHead}>{name}</Typography>
        {keyName === "ID" ? (
          <FormattedInput
            className={
              valueError ? classes.fieldInputError : classes.fieldInput
            }
            type="text"
            placeholder={placeholder}
            onChange={(formattedValue, raw) => {
              this.setState({
                [keyName]: raw,
                [errorKeyName]: false
              });
              localStorage.setItem(buyFor + keyName, raw);
              localStorage.setItem(buyFor + "lastSave", new Date().getTime());
            }}
            value={value}
            format={[
              { char: /[\dX]/, repeat: 1 },
              { exactly: "-" },
              { char: /[\dX]/, repeat: 4 },
              { exactly: "-" },
              { char: /[\dX]/, repeat: 5 },
              { exactly: "-" },
              { char: /[\dX]/, repeat: 2 },
              { exactly: "-" },
              { char: /[\dX]/, repeat: 1 }
            ]}
          />
        ) : (
          <input
            value={value}
            onChange={event => {
              this.setState({
                [keyName]: event.target.value,
                [errorKeyName]: false
              });
              localStorage.setItem(buyFor + keyName, event.target.value);
              localStorage.setItem(buyFor + "lastSave", new Date().getTime());
            }}
            className={
              valueError ? classes.fieldInputError : classes.fieldInput
            }
            type="text"
            placeholder={placeholder}
          />
        )}
        {valueError && (
          <span className={classes.errorText}>
            {this.renderErrorText(keyName, value)}
          </span>
        )}
      </div>
    );
  };

  renderTwoTextInput = (
    name1,
    keyName1,
    errorKeyName1,
    placeholder1,
    otherProps1 = {},
    name2,
    keyName2,
    errorKeyName2,
    placeholder2,
    otherProps2 = {}
  ) => {
    const { classes, auth = {} } = this.props;
    const { buyFor = "self" } = auth;
    let value1 = _.get(this.state, keyName1, "");
    const valueError1 = _.get(this.state, errorKeyName1, false);
    let value2 = _.get(this.state, keyName2, "");
    const valueError2 = _.get(this.state, errorKeyName2, false);
    const loaded1 = _.get(this.state, keyName1 + "Load", false);
    if (
      !!localStorage.getItem(buyFor + keyName1) &&
      !!loaded1 === false &&
      parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
        new Date().getTime()
    ) {
      value1 = localStorage.getItem(buyFor + keyName1);
      this.state[keyName1 + "Load"] = true;
      this.state[keyName1] = value1;
    } else {
      if (loaded1 === false) {
        this.state[keyName1 + "Load"] = true;
        localStorage.setItem(buyFor + keyName1, value1);
      }
    }
    const loaded2 = _.get(this.state, keyName2 + "Load", false);
    if (
      !!localStorage.getItem(buyFor + keyName2) &&
      !!loaded2 === false &&
      parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
        new Date().getTime()
    ) {
      value2 = localStorage.getItem(buyFor + keyName2);
      this.state[keyName2 + "Load"] = true;
      this.state[keyName2] = value2;
    } else {
      if (loaded2 === false) {
        this.state[keyName2 + "Load"] = true;
        localStorage.setItem(buyFor + keyName2, value2);
      }
    }
    return (
      <div className={classes.flexSpace}>
        <div className={classes.twoContainer}>
          <Typography className={classes.inputHead}>{name1}</Typography>
          <input
            ref={keyName1}
            value={value1}
            onChange={event => {
              this.setState({
                [keyName1]: event.target.value,
                [errorKeyName1]: false
              });
              localStorage.setItem(buyFor + keyName1, event.target.value);
              localStorage.setItem(buyFor + "lastSave", new Date().getTime());
            }}
            className={
              valueError1 ? classes.fieldInputError : classes.fieldInput
            }
            type="text"
            placeholder={placeholder1}
          />
          {valueError1 && (
            <span className={classes.errorText}>
              {this.renderErrorText(keyName1, value1)}
            </span>
          )}
        </div>
        <div className={classes.divider} />
        <div className={classes.twoContainer}>
          <Typography className={classes.inputHead}>{name2}</Typography>
          <input
            ref={keyName2}
            value={value2}
            onChange={event => {
              this.setState({
                [keyName2]: event.target.value,
                [errorKeyName2]: false
              });
              localStorage.setItem(buyFor + keyName2, event.target.value);
              localStorage.setItem(buyFor + "lastSave", new Date().getTime());
            }}
            className={
              valueError2 ? classes.fieldInputError : classes.fieldInput
            }
            type="text"
            placeholder={placeholder2}
          />
          {valueError2 && (
            <span className={classes.errorText}>
              {this.renderErrorText(keyName2, value2)}
            </span>
          )}
        </div>
      </div>
    );
  };

  renderEffdate = () => {
    const name1 = "ตั้งแต่";
    const keyName1 = "effDate";
    const errorKeyName1 = "effDateError";
    const placeholder1 = "";
    const otherProps1 = {};
    const name2 = "ถึง";
    const keyName2 = "toDate";
    const { classes, auth = {} } = this.props;
    const { buyFor = "self" } = auth;
    let value1 = _.get(this.state, keyName1, "");
    const valueError1 = _.get(this.state, errorKeyName1, false);
    let value2 = moment(value1)
      .add(1, "years")
      .subtract(1, "days")
      .format("YYYY-MM-DD");
    const loaded1 = _.get(this.state, keyName1 + "Load", false);
    if (
      !!localStorage.getItem(buyFor + keyName1) &&
      !!loaded1 === false &&
      parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
        new Date().getTime()
    ) {
      value1 = localStorage.getItem(buyFor + keyName1);
      this.state[keyName1 + "Load"] = true;
      this.state[keyName1] = value1;
    } else {
      if (loaded1 === false) {
        this.state[keyName1 + "Load"] = true;
        localStorage.setItem(buyFor + keyName1, value1);
      }
    }
    return (
      <div className={classes.flexSpace}>
        <div className={classes.twoContainer}>
          <Typography className={classes.inputHead}>{name1}</Typography>
          <div ref={keyName1} className={classes.inputContainerDisable}>
            <span
              className={
                !!value1 ? classes.fieldValue : classes.fieldValueBlank
              }
            >
              {value1}
            </span>
          </div>
        </div>
        <div className={classes.divider} />
        <div className={classes.twoContainer}>
          <Typography className={classes.inputHead}>{name2}</Typography>
          <div ref={keyName2} className={classes.inputContainerDisable}>
            <span
              className={
                !!value2 ? classes.fieldValue : classes.fieldValueBlank
              }
            >
              {value2}
            </span>
          </div>
        </div>
      </div>
    );
  };

  renderBirthdate = () => {
    const name = "วัน/เดือน/ปีเกิด";
    const keyName = "birthdate";
    const errorKeyName = "birthdateError";
    const placeholder = "DD/MM/YYYY";
    const otherProps = {};
    const { classes, auth = {} } = this.props;
    const { buyFor = "" } = auth;
    let value = _.get(this.state, keyName, "");
    const valueError = _.get(this.state, errorKeyName, false);
    const loaded = _.get(this.state, keyName + "Load", false);
    if (
      !!localStorage.getItem(buyFor + keyName) &&
      !!loaded === false &&
      parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
        new Date().getTime()
    ) {
      value = localStorage.getItem(buyFor + keyName);
      this.state[keyName + "Load"] = true;
      this.state[keyName] = value;
    } else {
      if (loaded === false) {
        this.state[keyName + "Load"] = true;
        localStorage.setItem(buyFor + keyName, value);
      }
    }
    return (
      <div>
        <Typography className={classes.inputHead}>{name}</Typography>
        <div
          ref={keyName}
          className={
            !!valueError ? classes.inputContainerError : classes.inputContainer
          }
          onClick={() => {
            this.setState({
              datePickerBirthdate: true
            });
          }}
        >
          <span
            className={!!value ? classes.fieldValue : classes.fieldValueBlank}
          >
            {value ? value : placeholder}
          </span>
          <Icon style={{ color: "#4b5161", fontSize: "24px" }}>
            keyboard_arrow_down
          </Icon>
        </div>
        {valueError && (
          <span className={classes.errorText}>
            {this.renderErrorText(keyName, value)}
          </span>
        )}
      </div>
    );
  };

  renderPicker = (
    name,
    keyName,
    errorKeyName,
    placeholder,
    choices,
    otherProps = {}
  ) => {
    const { classes, auth = {} } = this.props;
    const { buyFor = "self" } = auth;
    let value = _.get(this.state, keyName, "");
    const valueError = _.get(this.state, errorKeyName, false);
    const loaded = _.get(this.state, keyName + "Load", false);
    if (
      !!localStorage.getItem(buyFor + keyName) &&
      !!loaded === false &&
      parseInt(localStorage.getItem(buyFor + "lastSave")) + 900000 >
        new Date().getTime()
    ) {
      value = localStorage.getItem(buyFor + keyName);
      this.state[keyName + "Load"] = true;
      this.state[keyName] = value;
    } else {
      if (loaded === false) {
        this.state[keyName + "Load"] = true;
        localStorage.setItem(buyFor + keyName, value);
      }
    }
    return (
      <div>
        <Typography className={classes.inputHead}>{name}</Typography>
        <div
          ref={keyName}
          className={
            !!valueError ? classes.inputContainerError : classes.inputContainer
          }
          onClick={() => {
            this.setState({
              isShowPicker: true,
              pickerChoices: choices,
              pickerClick: data => {
                this.setState({
                  [keyName]: data.name,
                  [errorKeyName]: false
                });
                localStorage.setItem(buyFor + keyName, data.name);
                localStorage.setItem(buyFor + "lastSave", new Date().getTime());
              }
            });
          }}
        >
          <span
            className={!!value ? classes.fieldValue : classes.fieldValueBlank}
          >
            {value ? value : placeholder}
          </span>
          <Icon style={{ color: "#4b5161", fontSize: "12px" }}>
            arrow_forward_ios
          </Icon>
        </div>
        {valueError && (
          <span className={classes.errorText}>
            {this.renderErrorText(keyName, value)}
          </span>
        )}
      </div>
    );
  };

  render = () => {
    const { classes, auth = {} } = this.props;
    const { moreAddress = {}, buyFor = "self" } = auth;
    const {
      profiter,
      hadInsurance,
      chiTravel,
      reject,
      wasDisease,
      conDisease,
      tax,
      sendingResult,
      sendingMail,
      agree,
      isShowPicker,
      pickerChoices,
      pickerClick,
      datePickerEffDate,
      datePickerBirthdate,
      effDate,
      birthdate,
      isShowAddressPicker,
      moreAddressError
    } = this.state;
    return (
      <Wrapper>
        <Body>
          <div className={classes.sectionMargin}>
            <Typography className={classes.cardHead}>
              ข้อมูลส่วนตัวผู้เอาประกันภัย
            </Typography>
            {this.renderTextInput(
              "อีเมล",
              "email",
              "emailError",
              "example@email.com"
            )}
            {this.renderTextInput(
              "เบอร์โทรศัพท์",
              "phoneNumber",
              "phoneNumberError",
              "08x-xxx-xxxx"
            )}
            {this.renderTextInput(
              "เลขบัตรประชาชน",
              "ID",
              "IDError",
              "9-9999-99999-99-9"
            )}
            {this.renderPicker(
              "คำนำหน้า",
              "gender",
              "genderError",
              "เลือกคำนำหน้า",
              genderData
            )}
            {this.renderTextInput(
              "ชื่อจริง (ภาษาไทย)",
              "firstName",
              "firstNameError",
              ""
            )}
            {this.renderTextInput(
              "นามสกุล (ภาษาไทย)",
              "lastName",
              "lastNameError",
              ""
            )}
            {this.renderBirthdate()}
            {this.renderTwoTextInput(
              "น้ำหนัก (กก.)",
              "weight",
              "weightError",
              "",
              {},
              "ส่วนสูง (ซม.)",
              "height",
              "heightError",
              "",
              {}
            )}
          </div>
          <div className={classes.sectionMargin}>
            <Typography className={classes.cardHead}>
              ที่อยู่ (ภาษาไทย)
            </Typography>
            {this.renderTwoTextInput(
              "บ้านเลขที่",
              "homeNo",
              "homeNoError",
              "",
              {},
              "หมู่",
              "moo",
              "mooError",
              "",
              {}
            )}
            {this.renderTextInput(
              "ชื่ออาคาร/หมู่บ้าน",
              "building",
              "buildingError",
              ""
            )}
            {this.renderTextInput("ซอย", "soi", "soiError", "")}
            {this.renderTextInput("ถนน", "road", "roadError", "")}
            <div>
              <Typography className={classes.inputHead}>
                จังหวัด, อำเภอ, ตำบล
              </Typography>
              <div
                ref={"moreAddress"}
                className={
                  !!moreAddressError
                    ? classes.inputContainerError
                    : classes.inputContainer
                }
                onClick={() => {
                  this.setState({
                    isShowAddressPicker: true,
                    moreAddressError: false
                  });
                }}
              >
                <span
                  className={
                    !!_.get(moreAddress, "fullAddress", "")
                      ? classes.fieldValue
                      : classes.fieldValueBlank
                  }
                >
                  {!!_.get(moreAddress, "fullAddress", "")
                    ? _.get(moreAddress, "fullAddress", "")
                    : "เลือกข้อมูล"}
                </span>
                <Icon style={{ color: "#4b5161", fontSize: "12px" }}>
                  arrow_forward_ios
                </Icon>
              </div>
              {moreAddressError && (
                <span className={classes.errorText}>
                  {this.renderErrorText("moreAddress", moreAddress)}
                </span>
              )}
            </div>
          </div>
          <div className={classes.sectionMargin}>
            <Typography className={classes.cardHead}>
              ผู้รับผลประโยชน์
            </Typography>
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend" />
              <RadioGroup
                aria-label="position"
                name="position"
                value={profiter}
                onChange={event => {
                  this.setState({ profiter: event.target.value });
                }}
                row
              >
                <FormControlLabel
                  value="relation"
                  control={<Radio color="primary" />}
                  label="ทายาทตามกฏหมาย"
                  labelPlacement="end"
                />
                <FormControlLabel
                  value="other"
                  control={<Radio color="primary" />}
                  label="อื่นๆ"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
            {profiter !== "relation" && (
              <div>
                {this.renderPicker(
                  "ความสัมพันธ์",
                  "profiterRelation",
                  "profiterRelationError",
                  "เลือกความสัมพันธ์",
                  relationData
                )}
                {this.renderPicker(
                  "คำนำหน้า",
                  "profiterGender",
                  "profiterGenderError",
                  "เลือกคำนำหน้า",
                  gender2Data
                )}
                {this.renderTextInput(
                  "ชื่อจริง (ภาษาไทย)",
                  "profiterFirstName",
                  "profiterFirstNameError",
                  ""
                )}
                {this.renderTextInput(
                  "นามสกุล (ภาษาไทย)",
                  "profiterLastName",
                  "profiterLastNameError",
                  ""
                )}
              </div>
            )}
          </div>
          <div className={classes.sectionMargin}>
            <Typography className={classes.cardHead}>วันที่คุ้มครอง</Typography>
            {this.renderEffdate()}
          </div>
          <div className={classes.sectionMargin}>
            <Typography className={classes.cardHead}>
              รายละเอียดเพิ่มเติม
            </Typography>
            <br />
            {/*<div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>1.</Typography>
                <Typography className={classes.numberText}>
                  ในระหว่าง 14 วันที่ผ่านมา ท่านได้เดินทางไปยัง
                  ประเทศจีนหรือไม่?
                </Typography>
              </div>
              <div className={classes.radioContainer}>
                <FormControl component="fieldset">
                  <FormLabel component="legend" />
                  <RadioGroup
                    aria-label="position"
                    name="position"
                    value={chiTravel}
                    onChange={event => {
                      this.setState({ chiTravel: event.target.value });
                      localStorage.setItem(
                        buyFor + "chiTravel",
                        event.target.value
                      );
                      localStorage.setItem(
                        buyFor + "lastSave",
                        new Date().getTime()
                      );
                    }}
                    row
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio color="primary" />}
                      label="เคย/มี"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio color="primary" />}
                      label="ไม่เคย/ไม่มี"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>*/}
            <div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>1.</Typography>
                <Typography className={classes.numberText}>
                  ผู้ขอเอาประกันภัยประสงค์จะใช้สิทธิขอยกเว้น
                  ภาษีเงินได้ตามกฎหมายว่าด้วยภาษีอากรหรือไม่?
                </Typography>
              </div>
              <div className={classes.radioContainerFull}>
                <FormControl component="fieldset">
                  <FormLabel component="legend" />
                  <RadioGroup
                    aria-label="position"
                    name="position"
                    value={tax}
                    onChange={event => {
                      this.setState({ tax: event.target.value });
                      localStorage.setItem(buyFor + "tax", event.target.value);
                      localStorage.setItem(
                        buyFor + "lastSave",
                        new Date().getTime()
                      );
                    }}
                    row
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio color="primary" />}
                      label="มีความประสงค์ และยินยอมให้บริษัทประกันวินาศภัย
ส่งและเปิดเผยข้อมูลเกี่ยวกับเบี้ยประกันภัยต่อ
กรมสรรพากร ตามหลักเกณฑ์ วิธีการที่
กรมสรรพากรกำหนด และหากผู้ขอเอาประกันภัย
เป็นชาวต่างชาติ ( Non-Thai Residence )
ซึ่งเป็นผู้มีหน้าที่ต้องเสียเงินได้ตามกฎหมายว่าด้วย
ภาษีอากร โปรดระบุเลขประจำตัวผู้เสียภาษี"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio color="primary" />}
                      label="ไม่มีความประสงค์ ทั้งนี้การยินยอมให้ส่งและ
เปิดเผยข้อมูลข้างต้นจะมีผลบังคับจนกว่า
ผู้เอาประกันภัยจะแจ้งยกเลิกหรือเปลี่ยนแปลง
ต่อบริษัทฯ"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
          </div>
          <div className={classes.section}>
            <Typography
              style={{
                ...fontDefault,
                fontSize: "14px",
                color: "rgb(102 102 102)",
                textAlign: "center",
                marginBottom: "16px"
              }}
            >
              ข้าพเจ้าขอรับกรมธรรม์ทางอีเมลตามที่ระบุไว้ข้างต้น
            </Typography>
            <SubmitButton onClick={this.goToNextPage} margin={false}>
              ถัดไป
            </SubmitButton>
          </div>
          <Picker
            open={isShowPicker}
            choices={pickerChoices}
            onClick={pickerClick}
            onBack={() => {
              this.setState({ isShowPicker: false });
            }}
            history={this.props.history}
          />
          <DatePicker
            value={new Date(effDate + "T07:00:00")}
            isOpen={datePickerEffDate}
            onSelect={time => {
              this.setState({
                effDate: moment(time).format("YYYY-MM-DD"),
                datePickerEffDate: false,
                effDateError: false
              });
            }}
            onCancel={() => {
              this.setState({
                datePickerEffDate: false
              });
            }}
            confirmText="ตกลง"
            cancelText="ยกเลิก"
            showHeader={false}
            min={moment()
              .subtract(1, "day")
              .toDate()}
            max={moment()
              .add(6, "months")
              .toDate()}
            showCaption
            dateConfig={{
              date: {
                format: "D",
                caption: "วัน",
                step: 1
              },
              month: {
                format: "MM",
                caption: "เดือน",
                step: 1
              },
              year: {
                format: "YYYY",
                caption: "ปี",
                step: 1
              }
            }}
          />
          <DatePicker
            value={new Date(birthdate + "T07:00:00")}
            isOpen={datePickerBirthdate}
            onSelect={time => {
              this.setState({
                birthdate: moment(time).format("YYYY-MM-DD"),
                datePickerBirthdate: false,
                birthdateError: false
              });
              localStorage.setItem(
                buyFor + "birthdate",
                moment(time).format("YYYY-MM-DD")
              );
            }}
            onCancel={() => {
              this.setState({
                datePickerBirthdate: false
              });
            }}
            confirmText="ตกลง"
            cancelText="ยกเลิก"
            showHeader={false}
            min={moment()
              .subtract(99, "years")
              .toDate()}
            max={moment()
              .subtract(1, "years")
              .toDate()}
            showCaption
            dateConfig={{
              date: {
                format: "D",
                caption: "วัน",
                step: 1
              },
              month: {
                format: "MM",
                caption: "เดือน",
                step: 1
              },
              year: {
                format: "YYYY",
                caption: "ปี",
                step: 1
              }
            }}
          />
          <AddressPicker
            open={isShowAddressPicker}
            onBack={() => {
              this.setState({
                isShowAddressPicker: false
              });
            }}
            history={this.props.history}
          />
        </Body>
        <Header>
          <TopBar arrowLeft={this.backToPreviousPage} progress={2}>
            <Typography align="center" className={classes.textTopBar}>
              กรอกข้อมูลเพิ่มเติม
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth || {}
  };
};

export default connect(mapStateToProps)(withStyles(styles)(App));
